import React from 'react';

var SnapshotVersionPopup = React.createClass({
	getInitialState: function(){
		return { versionLabel: {"label": "" }, "sort": "date", "isSort": true, errMsg: "", error: false, errorclass: ""}
	},
	handleCancelClick: function(){
		this.props.snapshot("close");
	},
	handleSnapshotClick: function(){
		var version = this.state.versionLabel.label.trim();
		var isValid=(function(){
          var rg1=/^[^\\/:\*\?"<>\|\]&!@#$%^*/[()+={};',`~]+$/; // forbidden characters \ / : * ? " < > |
          var rg2=/^\./; // cannot start with dot (.)
          var rg4=/^-/; // cannot start with dash (-)
          var rg5=/^_/; // cannot start with underscore (_)
          // var rg3=/^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i; // forbidden file names
          return function isValid(fname){
            return rg1.test(fname)&&!rg2.test(fname)&&!rg4.test(fname)&&!rg5.test(fname);
          }
        })();

        if(version.length > 255){
          this.setState({errMsg: "Input characters should not be exceeded by 255 characters.", error: true, errorclass: "field__error--input"});
          return;
        }

        if(version.trim() === ""){
        	this.setState({errMsg: "Please enter a Version Snapshot Label.", error: true, errorclass: "field__error--input"});	
        	return;
        }

        if(version.length <= 0 || version === "" || !isValid(version) || version.indexOf(' ') > 0){
          this.setState({errMsg: "Entered Version Snapshot Label is invalid. Spaces and special characters are not allowed except .,_ and-.", error: true, errorclass: "field__error--input"});
          return;
        }

		this.props.snapshot("submit", this.state.versionLabel.label.trim(), this.props.data);
	},
	componentWillReceiveProps: function(nextProps){
		if(nextProps.errors.error && !nextProps.errors.popup){
			this.setState({	error: true, 
							errorclass: "field__error--input", 
							errMsg: nextProps.errors.message});
		} else {
			this.setState({error: false, errorclass: "", errMsg:""});
		}
	},
	makeCanonicalSnapshot: function(label){
		this.props.makeCanonicalSnapshot(label, this.props.data);
	},
	handleDateClick: function(){
		this.setState({"sort": "date", isSort: !this.state.isSort});
	},
	handleLabelClick: function(){
		this.setState({"sort": "label", isSort: !this.state.isSort});
	},
	handleChange: function(value){
		this.setState({versionLabel: {"label":value }, errMsg: "", errorclass: "", error: false});
	},
	handleOutsideClick: function(e){
		e.stopPropagation();
		$(".ver__status--container").removeClass('clicked'); // closes make canonical popup
	},
	render: function(){
		return(
			<div className="modal__mask" onClick = {this.handleCancelClick}>
				<div className="modal__content modal--md" onClick = {this.handleOutsideClick}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Create Version Snapshot</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}><i className="fa  fa-close"> </i></a> </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>You have {this.props.data.length} version Snapshots of package <strong>"{this.props.themeName}"</strong>.</p>
				    </div>
				    {(this.props.data instanceof Array && this.props.data.length) > 0 ?
				    <SnapshotVersions 	data = {this.props.data}
				    					makeCanonicalSnapshot = {this.makeCanonicalSnapshot}
				    					handleDateClick = {this.handleDateClick}
				    					sort = {this.state.sort}
				    					handleLabelClick= {this.handleLabelClick} 
				    					isSort = {this.state.isSort}/> : null }
				    <VersionLabel 	versionLabel = {this.state.versionLabel}
				    				errMsg = {this.state.errMsg}
				    				errorclass = {this.state.errorclass}
				    				error = {this.state.error}
				    				handleChange = {this.handleChange} />
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.handleCancelClick}>Cancel</button>
				      <button className="btn__lg bg-dark" onClick = {this.handleSnapshotClick}>Snapshot</button>
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

var SnapshotVersions  = React.createClass({
	// componentDidMount: function(){
	// 	$('.ver__status--container').on('click', function(e){
	// 	    e.stopPropagation();  // this function is same as handleVersionClick but for stopPropogation
	// 	});
	// },
	handleVersionClick: function(name, event){
		event.stopPropagation();
		/* for opening the make canonical popup */
		if(name === "make"){
			var e = event.target.parentElement.firstChild;
		} else {
			var e = event.target.parentElement;
		}
		$(".ver__status--container").not(e).removeClass('clicked'); // closes make canonical popup
	    var $menuItem = $(e),
	        $submenuWrapper = $('> .tooltip', $menuItem);
	    
	    // grab the menu item's position relative to its positioned parent
	    var menuItemPos = $menuItem.position();
	    
	    // place the submenu in the correct position relevant to the menu item
	    $submenuWrapper.css({
	      top: menuItemPos.top + Math.round($menuItem.outerWidth() * 1),
	      left: menuItemPos.left + Math.round($menuItem.outerWidth() * .4)
	    });

		$(e).toggleClass('clicked');

	},
	formatAMPM: function(date) {
	  	var hours = date.getHours();
	  	var minutes = date.getMinutes();
	  	var ampm = hours >= 12 ? 'pm' : 'am';
	  	hours = hours % 12;
	  	hours = hours ? hours : 12; // the hour '0' should be '12'
	  	minutes = minutes < 10 ? '0'+minutes : minutes;
	  	var strTime = hours + ':' + minutes  + ampm;
	  	return strTime;
	},
	handleMakeCanonicalClick: function(label, e){  //opens the make canonical popup
		this.props.makeCanonicalSnapshot(label);
		$(e.target.parentElement.parentElement.parentElement).toggleClass('clicked');
	},
	handleCancelCanocicalClick: function(label, e){ // closes the make canonocal popup
		$(e.target.parentElement.parentElement.parentElement).toggleClass('clicked');
	},
	handleScroll: function(){
		$(".ver__status--container").removeClass('clicked'); // closes make canonical popup
	},
	sort: function(sortName){
		if(this.props.sort === "date" && this.props.isSort){
			this.props.data.sort(function(a,b){
			  return new Date(b.created_date) - new Date(a.created_date);  // for sorting date wise
			});
		} else if (this.props.sort === "date" && !this.props.isSort){
			this.props.data.sort(function(a,b){
			  return new Date(a.created_date) - new Date(b.created_date);  // for sorting date wise
			});
		}

		if(this.props.sort === "label" && this.props.isSort){
			this.props.data.sort(function(a, b){
			    var nameA=a.label.toLowerCase(), nameB=b.label.toLowerCase()
			    if (nameA < nameB) //sort string ascending
			        return -1 
			    if (nameA > nameB)
			        return 1
			    return 0 //default return value (no sorting)
			});
		} else if(this.props.sort === "label" && !this.props.isSort) {
			this.props.data.sort(function(a, b){
			    var nameA=a.label.toLowerCase(), nameB=b.label.toLowerCase()
			    if (nameB < nameA) //sort string descending
			        return -1 
			    if (nameB > nameA)
			        return 1
			    return 0 //default return value (no sorting)
			});
		}

	},
	render: function(){
		this.sort(this.props.sort);	 // for sortings
		var data = this.props.data;
		var flag = false;
		for (var i in data){
			if(this.props.data[i]["canonical"]){
				flag = true;
			}
		}
		/*for the recent date in the data */
		var recentDate = new Date(Math.max.apply(null, data.map(function(e) {
		  return new Date(e.created_date);
		})));

		var result = data.map(function(value, index){
			var date = new Date(value["created_date"]);
			var dateInString = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(-2) + ", " + this.formatAMPM(date);
			if (value["canonical"]){
				return (<li className="ver__item canonical__item" key = {index}>
			              <div className="ver__label">{value["label"]}</div>
			              <div className="ver__status"> 
			              	<a href="javascript:void(0)" className="tooltip__container ver__status--container">
			              		<i className="fa fa-star"></i> 
			              	</a> 
			              	<span className="ver__status--visible">canonical</span>
			               </div>
			              <div className="ver__date_n_time">{dateInString}</div>
			            </li>
			    );
			} else {
				if(!flag && (recentDate.valueOf() === new Date(value.created_date).valueOf())){
					return (
						<li className="ver__item recent__item" key = {index}>
			              	<div className="ver__label">{value["label"]}</div>
			              	<div className="ver__status">
			               		<a href="javascript:void(0)" className="tooltip__container ver__status--container no__hover" onClick = {this.handleVersionClick.bind(this, "star")}><i className= "fa fa-star"></i> 
			                		{/*<div className="tooltip tooltip--bottom tooltip--lg">
			                			<div className="form__row clearfix">
			                  				<h6>Make Version Snapshot Canonical</h6>
			                  				<p>The canonical version of a package represents the default version, unless otherwise specified. Your canonical version will be used for clone and pull.</p>
			                			</div>
			                			<div className="buttons clearfix">
			                  				<button className="btn__sm bg-very_light" onClick = {this.handleCancelCanocicalClick.bind(this, value["label"])}>Cancel</button>
			                 				<button className="btn__sm bg-dark" onClick = {this.handleMakeCanonicalClick.bind(this, value["label"])}>Make Canonical</button>
			                			</div>
			                		</div>*/}
			               		</a>
			               		<span className="ver__status--visible" onClick = {this.handleVersionClick.bind(this, "make")}>most recent</span>
			                	<span className="ver__status--hidden" onClick = {this.handleVersionClick.bind(this, "make")}>most recent{/*make canonical*/}</span>
			              	</div>
			              	<div className="ver__date_n_time">{dateInString}</div>
			            </li>
					);
				} else {
					return (
						<li className="ver__item recent__item" key = {index}>
			              	<div className="ver__label">{value["label"]}</div>
			              	<div className="ver__status">
			               		<a href="javascript:void(0)" className="tooltip__container ver__status--container no__hover" onClick = {this.handleVersionClick.bind(this, "star")}><i className= "fa fa-star-o"></i> 
			                		{/*<div className="tooltip tooltip--bottom tooltip--lg">
			                			<div className="form__row clearfix">
			                  				<h6>Make Version Snapshot Canonical</h6>
			                  				<p>The canonical version of a package represents the default version, unless otherwise specified. Your canonical version will be used for clone and pull.</p>
			                			</div>
			                			<div className="buttons clearfix">
			                  				<button className="btn__sm bg-very_light" onClick = {this.handleCancelCanocicalClick.bind(this, value["label"])}>Cancel</button>
			                 				<button className="btn__sm bg-dark" onClick = {this.handleMakeCanonicalClick.bind(this, value["label"])}>Make Canonical</button>
			                			</div>
			                		</div>*/}
			               		</a>
			               		<span className="ver__status--visible" onClick = {this.handleVersionClick.bind(this, "make")}>&zwnj;&zwnj;</span>
			                	<span className="ver__status--hidden" onClick = {this.handleVersionClick.bind(this, "make")}>&zwnj;&zwnj;{/*make canonical*/}</span>
			              	</div>
			              	<div className="ver__date_n_time">{dateInString}</div>
			            </li>
					);
				}
			}
		}, this);
		/*code for changing the up and down arrow when click on either label or date*/
		var dateclass, labelclass;
		if(this.props.sort === "date" && this.props.isSort){
			dateclass = "fa fa-angle-up";
			labelclass = "";
		} else if (this.props.sort === "date" && !this.props.isSort){
			dateclass = "fa fa-angle-down";
			labelclass = "";
		} else if (this.props.sort === "label" && this.props.isSort){
			dateclass = "";
			labelclass = "fa fa-angle-up";
		} else if (this.props.sort === "label" && !this.props.isSort){
			dateclass = "";
			labelclass = "fa fa-angle-down";
		}
		return (
				<div className="form__row clearfix">
			      <div className="ver__container">
			        <div className="ver__head clearfix"> 
			        	<strong className="ver__head--label">
			        		<a href="javascript:void(0)" onClick = {this.props.handleLabelClick}>Label<i className= {labelclass}></i></a>
			        	</strong>
			        	<strong className="ver__head--date ver__head--scroll">
			        		<a href="javascript:void(0)" onClick = {this.props.handleDateClick}>Date<i className={dateclass}></i></a>
			        	</strong> 
			        </div>
			        <div className="ver__body" onScroll = {this.handleScroll}>
			          <ul className="ver__list list-unstyled">
						{result}
			          </ul>
			        </div>
			      </div>
			    </div>
			);
	}
});

var VersionLabel = React.createClass({
	handleChange: function(e){
		this.props.handleChange(e.target.value);
	},
	render: function(){
		return (
			<div className="form__row clearfix">
			    <div className="form__cell">
			       	<label>
			       		<strong>Enter Version Snapshot Label </strong> 
			       		<a href="javascript:void(0)" className="tooltip__container">
			       			<i className="fa fa-question-circle"></i> 
			       			<span className="tooltip tooltip--top tooltip--md">Means the unique label name given to distinguish between package versions. Version label can be any value which contains letters, numbers and/or underscores.</span>
			       		</a>
			       	</label>
			    </div>
				<div className="form__cell">
			      {this.props.error ?
			       	<p className ="field__error--text">{this.props.errMsg}</p> : null }
			        <div className="inline_form">
			          <div className = {this.props.errorclass}>
			          	<input type="text" value={this.props.versionLabel.label} onChange = {this.handleChange}/>
			          </div>
			        </div>
			    </div>
		
		    </div>
		);
	}
});

export {SnapshotVersionPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SnapshotVersionPopup.jsx
 **/